import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import HeaderGOCEn from "../../assets/sig-blk-en.svg";
import HeaderGOCFr from "../../assets/sig-blk-fr.svg";
import { useState, useEffect } from "react";

export default function Header() {
  const { language, setLanguage } = useLanguage();
  const t = translations[language];
  const headerSignature = language === "fr" ? HeaderGOCFr : HeaderGOCEn;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "fr" : "en");
  };
  if (!isMobile) {
    return (
      <header className="bg-white sticky top-0 z-50 border-b border-gray-300">
        <div className="max-w-7xl mx-auto px-4">
          {/* Top row - Language toggle */}
          <div className="flex justify-end py-2">
            <h2 className="wb-inv">
              {t.languageSelection}
            </h2>
            <button
              onClick={toggleLanguage}
              className="text-sm text-blue-700 hover:underline font-semibold"
              lang={language === "en" ? "fr" : "en"}
            >
              {t.languageToggleLabel}
            </button>
          </div>

          {/* Bottom row - Logo */}
          <div className="flex items-end justify-between pb-4">
            <div style={{ width: "300px" }}>
              <img
                src={headerSignature}
                alt={t.governmentOfCanadaAlt}
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </div>
        </div>

        {/* Secondary Navigation Bar */}
        <nav className="bg-gray-100 border-t border-gray-300 border-b border-gray-300" aria-labelledby="appNavMenu">{/*"bg-white border-b border-t border-gray-300"*/}
          <h2 className="wb-inv" id="appNavMenu">
            {t.mainNavigationMenu}
          </h2>
          <div className="max-w-7xl mx-auto px-4">
            <ul className="flex space-x-8 list-none py-3">{/*"flex space-x-8 list-none py-4"*/}
              <li>
                <a
                  href="/apply/form"
                  className="text-gray-700 hover:text-blue-700 visited:text-gray-700 font-semibold"
                >
                  {t.applyNow}
                </a>
              </li>
              {/* <li>
                <a
                  href="/support"
                  className="text-gray-700 hover:text-blue-700 visited:text-gray-700 font-semibold"
                >
                  {t.defenceTeamCareersSupport}
                </a>
              </li> */}
              <li>
                <a
                  href="/report-issue"
                  className="text-gray-700 hover:text-blue-700 visited:text-gray-700 font-semibold"
                >
                  {t.reportAnIssue}
                </a>
              </li>
              <li>
                <a
                  href="/about-us"
                  className="text-gray-700 hover:text-blue-700 visited:text-gray-700 font-semibold"
                >
                  {t.aboutUs}
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  } else {
    return (
      <header className="bg-white sticky top-0 z-50 border-b border-gray-300">
        <div className="border-b border-gray-300">
          <div className="max-w-7xl mx-auto px-4">
            {/* Top row - Logo and Language toggle */}
            <div className="flex justify-between items-center py-4">
              <div style={{ width: "200px" }}>
                <img
                  src={headerSignature}
                  alt={t.governmentOfCanadaAlt}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
              <h2 className="wb-inv">
                {t.languageSelection}
              </h2>
              <button
                onClick={toggleLanguage}
                className="text-base text-[#26374a] font-semibold underline"
                lang={language === "en" ? "fr" : "en"}
              >
                {t.languageToggleAbbreviation}
              </button>
            </div>
          </div>
        </div>

        {/* Menu Button Section */}
        <div className="border-b border-gray-300">
          <div className="max-w-7xl mx-auto px-4 py-3">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="w-full py-2 px-3 text-center text-[#26374a] font-semibold border-2 border-[#26374a] rounded-lg text-sm"
            >
              Menu
            </button>
          </div>
        </div>

        {/* Collapsible Menu */}
        
        {mobileMenuOpen && (
          <nav className="bg-white border-b border-gray-300" aria-labelledby="appNavMenuMobile">
            <h2 className="wb-inv" id="appNavMenuMobile">
              {t.mainNavigationMenu}
            </h2>
            <div className="max-w-7xl mx-auto px-4">
              <ul className="flex flex-col space-y-3 list-none py-4">
                <li>
                  <a
                    href="/apply/form"
                    className="block w-full py-3 px-4 text-left text-[#26374a] bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded text-sm font-medium visited:text-[#26374a]"
                  >
                    {t.applyNow}
                  </a>
                </li>
                {/* <li>
                  <a
                    href="/support"
                    className="block w-full py-3 px-4 text-left text-[#26374a] bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded text-sm font-medium visited:text-[#26374a]"
                  >
                    {t.defenceTeamCareersSupport}
                  </a>
                </li> */}
                <li>
                  <a
                    href="/report-issue"
                    className="block w-full py-3 px-4 text-left text-[#26374a] bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded text-sm font-medium visited:text-[#26374a]"
                  >
                    {t.reportAnIssue}
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us"
                    className="block w-full py-3 px-4 text-left text-[#26374a] bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded text-sm font-medium visited:text-[#26374a]"
                  >
                    {t.aboutUs}
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        )}
      </header>
    );
  }
}
